export const ShowTypes = {
  ADMIN: "admin",
  USER: "user",
};

export const TypeComments = {
  NEED_WORK: "needWork",
  DOES_WELL: "doesWell",
};
